import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconArrowLeft } from '../../icons/svg';
import { BACKGROUND_CHATS } from '../../tinode/constants';
import ImagePopup from '../image-popup.jsx';
import { SCREEN } from '../info-view-content.jsx';

export default class Background extends React.PureComponent {
   constructor(props) {
      super(props);
      this.state = {
         showPopup: false,
         srcImg: ''
      }

      this.handleChangeBackground = this.handleChangeBackground.bind(this);
   }

   handleChangeBackground(index) {
      this.props.tinode.changeBackground(this.props.topic, index);
   }

   render() {
      return (
         <div className="info-image">
            <div className="header" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}>
               <div className="icon"><IconArrowLeft /></div>
               <div className="name">
                  <FormattedMessage id="info_change_background" defaultMessage="Change wallpaper" description="Change wallpaper" />
               </div>
            </div>
            <div className="list-image">
               {BACKGROUND_CHATS.map((img, index) => {
                  return (
                     <div className="img" key={index} onClick={() => this.handleChangeBackground(index)}>
                        <img src={img} alt="" />
                     </div>
                  )
               })}
            </div>
         </div>
      )
   }

}